<template>
  <div class="main col-xs-12">
    <AppMessages v-bind:message="this.message"
                 v-bind:show="this.show"
                 v-bind:type="this.messageType" />

    <h1>Send Update</h1>

    <form>
      <label class="label">Product</label>
      <selectize v-model="selectedProductId" :settings="selectizeSettings">
        <option v-for="product in products" :key="product.id" :value="product.id">
          {{ product.name }}
        </option>
      </selectize>
    </form>

    <div v-if="selectedProduct">
      <h2>Customers within the last 24 months</h2>
      <div v-if="showEmailError">
        <p style="color:red">Sorry, there is at least 1 customer who does not have a valid email address. Please rectify this before continuing.</p>
      </div>
      <table class="table">
        <thead>
          <tr>
            <th class="table__header">Customer</th>
            <th class="table__header">Customer Name</th>
            <th class="table__header">Email Addresses</th>
            <th class="table__header">Order Date</th>
          </tr>
        </thead>
        <tbody>
          <tr v-bind:key="spec.id" v-for="spec in specs">
            <td class="table__col">{{ spec.customer }}</td>
            <td class="table__col" >{{ spec.name }}</td>
            <td class="table__col" v-bind:class="{'table__error': spec.hasError}">
                {{ spec.email }}
            </td>
            <td class="table__col">{{ spec.orderdate | formatDate }}</td>
          </tr>
          <tr v-if="specs.length === 0">
            <td class="table__col" colspan="3">
              No records found
            </td>
          </tr>
        </tbody>
      </table>

      <form @submit.prevent="sendUpdate" v-if="specs.length > 0">
        <div class="form-group">
          <label class="label">Subject</label>
          <input class="input form-break" v-model="subject" :class="{ 'form-group--error': $v.subject.$error }" />
          <div class="error" v-if="!$v.subject.required">Subject is required</div>
        </div>

        <div class="form-group">
          <label class="label">Message</label>
          <textarea class="textarea" rows="10" v-model="emailmessage" :class="{ 'form-group--error': $v.emailmessage.$error }"></textarea>
          <div class="error" v-if="!$v.emailmessage.error">Message is required</div>
        </div>

        <div class="form-group">
          <div class="input__file">
            <button class="button">Upload</button>
            <input type="file"
                   name="fileuploads"
                   ref="fileuploads"
                   multiple
                   @change="onFileSelected"
                   :class="{ 'form-group--error': $v.fileuploads.$error }" />
            <label class="label label--alt" for="file">
              Choose a file
            </label>
            <div class="error" v-if="!$v.fileuploads.required">A file is required</div>
          </div>
          <ul v-if="fileuploads.length > 0">
            <li v-bind:key="file.name" v-for="file in fileuploads">
              {{ file.name }}  <a v-on:click="removeFile(file)" class="table__link">(Remove)</a>
            </li>
          </ul>
        </div>
        <div class="form-group">
          <button :disabled="!isSendEnabled" class="button button--alt button--clear" type="submit">Send Update</button>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import Selectize from 'vue2-selectize';
import { required } from 'vuelidate/lib/validators';
import axios from 'axios';
import AppMessages from '@/components/AppMessages/AppMessages.vue';
import Validation from '../validation'

export default {
  name: 'sendupdate',
  components: {
    Selectize,
    AppMessages,
  },
  data() {
    return {
        selectizeSettings: {
            maxOptions: 10000,
            sortField: [{ field: 'value', direction: 'asc' }, { field: '$score' }],
            allowEmptyOption: true,
            placeholder: 'Select value'
        },
      selectedProductId: null,
      selectedProduct: null,
      selectedProductName: null,
      specs: [],
      subject: '',
      emailmessage: '',
      fileuploads: [],
      products: [],
      message: '',
      messageType: '',
      show: false,
      isSendEnabled: true,
      showEmailError: false,
    };
  },
  watch: {
    selectedProductId(value) {
      const product = this.products.find(product => product.id === value) || null;
      this.selectedProduct = product;
      this.selectedProductName = product ? product.name : null;

       if (!value) {
         this.selectedProduct = null;
         this.subject = null;
         this.message = null;
        return;
      }

      this.loadData();
    },
  },
  mounted() {
    this.loadMasterProducts();
  },
  methods: {
    sendUpdate() {
      this.$v.$touch();
      if (this.$v.$invalid) {
        return;
      }

      this.$Progress.start();

      const formData = new FormData();
      formData.append('Subject', this.subject);
      formData.append('Body', this.emailmessage);

      for (let i = 0; i < this.fileuploads.length; i++) {
        const file = this.fileuploads[i];
        formData.append('Files', file);
      }

      const config = {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      };

      this.show = false;

      axios
        .post(`/products/${this.selectedProductName}/${this.selectedProductId}/send-email`, formData, config)
        .then((r) => {
          this.message = 'Email update sent';
          this.messageType = 'message message--success';
          this.show = true;

          this.emailmessage = null;
          this.subject = null;
          this.fileuploads = [];
          this.$v.$reset();
        })
        .catch((e) => {
          this.message = 'Email update not sent';
          this.messageType = 'message message--error';
          this.show = true;
          this.$Progress.fail();
        })
        .finally(() => {
          this.$Progress.finish();
        });
    },
    onFileSelected() {
      const { files } = this.$refs.fileuploads;

      for (let i = 0; i < files.length; i++) {
        this.fileuploads.push(files[i]);
      }
    },
    removeFile(file) {
      const index = this.fileuploads.indexOf(file);
      this.fileuploads.splice(index, 1);
    },
    loadMasterProducts() {
      this.$Progress.start();

      this.show = false;

      axios.get('/master-products')
        .then((r) => {
          this.products = r.data;
        })
        .catch((e) => {
          this.message = 'Products not loaded';
          this.messageType = 'message message--error';
          this.show = true;
          this.$Progress.fail();
        })
        .finally(() => {
          this.$Progress.finish();
        });
    },
    loadData() {
      if (!this.selectedProduct) return;

      this.$Progress.start();

      const $scope = this;
      this.specs = [];

      this.show = false;

      this.showEmailError = false;
      var canSend = true;

      axios.get(`/master-products/${this.selectedProductName}/${this.selectedProductId}/customers`)
        .then((r) => {
          const customers = r.data;
          for (let i = 0; i < customers.length; i++) {
            const customer = customers[i];

            var hasEmail = customer.emails && customer.emails.length > 0;

            if (!hasEmail) {
              canSend = false;
            }

            $scope.specs.push({
              customer: customer.customer,
              name: customer.name,
              email: customer.emails ? customer.emails.join(', ') : '',
              orderdate: customer.date,
              hasError : !hasEmail,
            });

          }

          this.isSendEnabled = canSend;
          this.showEmailError = !canSend;
        })
        .catch((e) => {

          if (e.response.data != undefined) {
              // temp array of { field, msg } values
            var batchErrors = [];
            var genericErrors = [];

            Validation.parseServerErrors(e.response.data, batchErrors, genericErrors);

            var errors = batchErrors.concat(genericErrors);

            var errorHtml = '';
            errors.forEach((e) => {
              errorHtml += `<p>${e}</p>`
            });

            this.message = `Encountered the following errors when sending update.${errorHtml}`;
            this.messageType = 'message message--error';
            this.show = true;
          }

          this.isSendEnabled = false;
          this.showEmailError = false;
          this.$Progress.fail();
        })
        .finally(() => {
          this.$Progress.finish();
        });
    },
  },
  validations: {
    subject: {
      required,
    },
    emailmessage: {
      required,
    },
    fileuploads: {
      required,
    },
  },
};
</script>
